import Vue from 'vue'
import VueResource from 'vue-resource'
import { resolve } from 'path';

Vue.use(VueResource)

var timeout = 0
var apiUrl = '/api/cps'
// apiUrl待定
function getMethod (method) {
    let staticResource = false
    if (method === 'static') {
        staticResource = true
        method = 'get'
    }
    return function (context, url, param, emulateJSON, timeout, requestKey) {
        return dataPromise(context, method, url, param, emulateJSON, staticResource, timeout, requestKey)
    }
}
function dataPromise (context, method, url, param, emulateJSON, staticResource, selfTimeout, requestKey) {
    if (emulateJSON === undefined) {
        emulateJSON = false
    }
    if (selfTimeout === undefined) {
        selfTimeout = timeout
    } else {
        selfTimeout = (selfTimeout < 0 || typeof selfTimeout !== 'number') ? 0 : selfTimeout
    }
    let result = null
    if ('post&put&patch'.indexOf(method) !== -1) {
        result = context.$http[method](getUrl(url, staticResource), param, {emulateJSON: emulateJSON})
    } else {
        result = context.$http[method](getUrl(url, staticResource), {params: param, emulateJSON: emulateJSON})
    }
    if (selfTimeout) {
        return Promise.race([
            result,
            new Promise((resolve,reject) => {
                setTimeout(() => {
                    reject(new Error('request timeout'))
                }, selfTimeout)
            })
        ])
    } else {
        return result
    }
}


function getUrl(url, staticResource) {
    return Vue.prototype.Config.SERVER_URL + (staticResource ? staticUrl : apiUrl) + url
}

export default {
    install: function (Vue, opt) {
        if (opt && typeof opt.timeout === 'number') {
            timeout = opt.timeout < 0 ? 0 : opt.timeout
        }
        apiUrl = (opt && opt.apiUrl) ? opt.apiUrl : apiUrl 
        Vue.prototype.$service = {
            get: getMethod('get'),
            delete: getMethod('delete'),
            post: getMethod('post'),
            put: getMethod('put'),
            patch: getMethod('patch')
        }
    }
}




// WEBPACK FOOTER //
// ./src/service/service.js